<div class="container">
  <div class="title-row">
    <h3 class="klabel-huge">Filter by Tag</h3>
    <app-button
      [text]="'De-select all'"
      class="grey"
      (click)="clearTagsFilter()"
    ></app-button>
  </div>
  <div class="content">
    <div class="section">
      <h4 class="section-title">Tag Selection</h4>

      <div class="checkbox-group">
        <div class="checkbox-item" *ngIf="tagList.length !== 0">
          <input
            type="checkbox"
            class="kinput"
            [checked]="
              tagList.length === mainFilter.tags.length &&
              tagList.length !== 0
            "
            (change)="selectAllTagsFilter($event)"
            id="selectAllTags"
          />
          <label for="selectAllTags" class="checkbox-label">
            Select all tags
            <mat-icon class="checkbox-icon" matTooltip="Select or deselect all tags at once" matTooltipPosition="above">help_outline</mat-icon>
          </label>
        </div>

        <div class="checkbox-item" *ngFor="let tag of tagList">
          <input
            type="checkbox"
            class="kinput"
            [checked]="checkIncludesRequirement(tag)"
            (change)="updateCheckboxFilter($event, tag)"
            [id]="'tag-' + tag?.tag"
          />
          <label [for]="'tag-' + tag?.tag" class="checkbox-label">
            {{ tag?.tag }}
            <mat-icon class="checkbox-icon" [matTooltip]="getTagHelpText(tag)" matTooltipPosition="above">help_outline</mat-icon>
          </label>
        </div>
      </div>
    </div>
  </div>
</div>
